import React, { useState } from "react";
import { Form } from "antd";
import { useAppDispatch } from "../../utils/hooks/redux";
import { useNavigate } from "react-router-dom";
import { forgotPasswordThunkAsync } from "../../redux/features/auth/authAsyncThunk";
import { FormContainer, FormInput, FormItem, FormTitle, InputLabel, LoginWrapper, SubmitButton } from "../Login/styles";
import { ReactComponent as LostAndFound } from "../../assets/images/Concierge.svg";
import { STATUS_CODE } from "../../utils/constants/auth";

interface ForgotPasswordFormProps {
  onSuccessSendMail: (email: string) => void;
}

const ForgotPasswordForm = ({ onSuccessSendMail }: ForgotPasswordFormProps) => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useAppDispatch();

  const handleSubmit = async (e: React.FormEvent) => {
    if (!email) return;
    e.preventDefault();

    try {
      setIsSubmitting(true);
      const response: any = await dispatch(forgotPasswordThunkAsync({ email })).unwrap();
      if (response?.success && response?.statusCode === STATUS_CODE.SUCCESS) {
        onSuccessSendMail(email);
      }
    } catch (error) {
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <LoginWrapper>
      <LostAndFound className="logoIcon" style={{ height: 48, width: "auto", marginBottom: "15px" }} />
      <FormContainer>
        <FormTitle level={3}>Forgot Password</FormTitle>

        <Form name="forgotPassword" onSubmitCapture={handleSubmit}>
          {/* Email Input */}
          <InputLabel>Your email</InputLabel>
          <FormItem name="email" required rules={[{ required: true, message: "Please enter a your email address" }]} normalize={(value) => value?.trim().toLowerCase() || ""}>
            <FormInput type="email" placeholder="Enter your email" value={email} onChange={(e: any) => setEmail(e.target.value)} />
          </FormItem>

          {/* Reset Button */}
          <SubmitButton loading={isSubmitting} type="primary" htmlType="submit">
            Recover Password
          </SubmitButton>
        </Form>
      </FormContainer>
    </LoginWrapper>
  );
};

export default ForgotPasswordForm;
